<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card card-top-line">
          <div class="header">
            <h2>Manage Users</h2>
          </div>
          <div class="body pt-0">
            <div
              class="chart-top-action d-lg-flex justify-content-end pb-2 pt-0"
            >
              <div class="d-md-flex justify-content-between">
                <b-button size="lg" variant="primary btn-mw" v-b-modal.add_user>
                  Add User
                  <i class="fa fa-plus-square"></i>
                </b-button>
              </div>
            </div>
            <b-modal id="add_user" title="Add User" hide-footer>
              <div class="body">
                <div class="modal-area">
                  <ValidationObserver v-slot="{ passes }">
                    <form id="bank-form" @submit.prevent="passes(createUser)">
                      <ValidationProvider
                        name="first_name"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div
                          class="form-group"
                          :class="{
                            errors: errors.length && !adduser.first_name,
                            success: adduser.first_name,
                          }"
                        >
                          <span class="float-label">
                            <input
                              type="text"
                              v-model="adduser.first_name"
                              class="form-control"
                              id="name"
                              placeholder="Name*"
                            />
                            <label for="name" class="control-label">
                              First Name *
                            </label>
                            <div class="line"></div>
                            <i
                              class="fa fa-times"
                              v-if="errors.length && !adduser.first_name"
                            ></i>
                            <i
                              class="fa fa-check"
                              v-if="adduser.first_name"
                            ></i>
                          </span>
                        </div>
                      </ValidationProvider>
                      <ValidationProvider
                        name="last_name"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div
                          class="form-group"
                          :class="{
                            errors: errors.length && !adduser.last_name,
                            success: adduser.last_name,
                          }"
                        >
                          <span class="float-label">
                            <input
                              type="text"
                              v-model="adduser.last_name"
                              class="form-control"
                              id="name"
                              placeholder="Name*"
                            />
                            <label for="name" class="control-label">
                              Last Name *
                            </label>
                            <div class="line"></div>
                            <i
                              class="fa fa-times"
                              v-if="errors.length && !adduser.last_name"
                            ></i>
                            <i class="fa fa-check" v-if="adduser.last_name"></i>
                          </span>
                        </div>
                      </ValidationProvider>
                      <ValidationProvider
                        name="email"
                        rules="required|email"
                        v-slot="{ errors }"
                      >
                        <div
                          class="form-group"
                          :class="{
                            errors: errors.length && !adduser.email,
                            success: adduser.email,
                          }"
                        >
                          <span class="float-label">
                            <input
                              type="text"
                              v-model="adduser.email"
                              class="form-control"
                              id="name"
                              placeholder="Name*"
                            />
                            <label for="name" class="control-label">
                              Email*
                            </label>
                            <div class="line"></div>
                            <i
                              class="fa fa-times"
                              v-if="errors.length && !adduser.email"
                            ></i>
                            <i class="fa fa-check" v-if="adduser.email"></i>
                          </span>
                        </div>
                      </ValidationProvider>
                      <div
                        class="align-items-center d-flex flex-column justify-content-between mt-3 w-100"
                      >
                        <b-button
                          type="submit"
                          variant="primary btn-mw"
                          size="lg"
                        >
                          Add Record
                        </b-button>
                        <b-button
                          @click="$bvModal.hide('add_user')"
                          size="lg"
                          variant="outline-secondary mt-3 btn-mw"
                        >
                          Cancel
                        </b-button>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </b-modal>
            <b-table
              responsive
              hover
              table-class="js-basic-example table-custom mb-0 border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #cell(action)>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item @click="showAlert">Delete</b-dropdown-item>
                  <b-dropdown-item>Reset Password</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
              v-if="totalRows > 10"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  hide-goto-end-buttons
                  hide-ellipsis
                  prev-text="Previous page"
                  next-text="Next page"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const { ValidationObserver, ValidationProvider } = require("vee-validate");
export default {
  name: "ManagePartnerUsers",
  components: {
    BreadCrumb,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      fields: [
        { key: "sl_no", label: "Sl No" },
        { key: "name", label: "Name" },
        { key: "email", label: "Email" },
        { key: "regDate", label: "Registration Date" },
        { key: "mainUser", label: "Main User" },
        { key: "action", label: "Action" },
      ],
      items: [
        {
          sl_no: 1,
          name: "James Smith",
          email: "jamessmith@mailinator.com",
          regDate: "2019-07-09 15:04:00",
          mainUser: "No",
        },
        {
          sl_no: 2,
          name: "delali Xavier",
          email: "delali@mailinator.com",
          regDate: "2019-07-09 15:04:00",
          mainUser: "No",
        },
      ],
      adduser: {
        first_name: "",
        last_name: "",
        email: "",
      },

      totalRows: 0,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, { value: 100, text: 100 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  methods: {
    createUser() {
      console.log("Data submited");
    },
    showAlert() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to delete this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success",
            );
          }
        });
    },
  },
  mounted() {
    this.totalRows = this.items.length;
  },
};
</script>
